var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',_vm._l((_vm.posts),function(post){return _c('section',{key:post.slug},[_c('h1',[_vm._v(_vm._s(post.title))]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.renderMarkdown(post.data))}})])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-062ce8f8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/posts.vue
// module id = null
// module chunks = 